<template>
<v-layout row justify-center>
  <v-dialog v-model="dialogGroup" width="600px">
    <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">
          <v-icon color="white">group</v-icon>&nbsp;&nbsp;{{$t('Dialog.anonymous.headerCreate')}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialogCreateGroup_ano">
          <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex sm12 md12 lg12 xl12>
            <!-- {{anoGroupDetail}} -->
            <p>{{$t('Dialog.anonymous.createGroupName')}}</p>
            <input type="text" :placeholder="$t('Dialog.anonymous.groupName')" class="CSChatThai inputgroupweb" v-model="GroupName">
            <v-checkbox v-model="checkbox" :label="$t('Dialog.anonymous.addMember')"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat="flat" :disabled="GroupName==''" @click="createGroup_ano()" class="CSChatThai">{{$t('AnswerQuestion.createGroup')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-layout>
</template>
<script type="text/javascript">
import {
  Decode
} from '@/services'
export default {
  props: {
    dialogGroup: false,
    anoGroupDetail: {}
  },
  data: () => ({
    GroupName: '',
    token: '',
    checkbox: true
  }),
  created() {
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  },
  watch: {
    anoGroupDetail() {
      this.GroupName = this.anoGroupDetail.pseudonym
    }
  },
  methods: {
    closeDialogCreateGroup_ano() {
      this.$emit('closeDialogCreateGroup_ano', false)
    },
    createGroup_ano() {
      this.axios.post(process.env.APIgo_api + '/v1/create-group-anonymous', {
        tokenuser: this.token,
        group_ref_id: this.anoGroupDetail.group_ref_id,
        add_owner: this.checkbox + '',
        group_name: this.GroupName
      }).then((response) => {
        if (response.data.status === 'success') {
          this.$swal('', this.$t('Alert.Success.createGroupChat'), 'success')
          this.closeDialogCreateGroup_ano()
        }
      }, () => {
        console.log('error')
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

a:link {
  text-decoration: none;
  color: black !important;
}

a:visited {
  color: white !important;
  text-decoration: none;
}

a:hover {
  color: #1e88e5 !important;
  text-decoration: none;
}

a:active {
  color: black !important;
  text-decoration: none;
}

>>>.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100% !important;
}

>>>.inputgroupweb {
  color: black !important;
  font-size: 16px !important;
}

input[type=text] {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #b7b7b7;
  border-radius: 30px;
  font-size: 16px;
  background-color: white;
  background-image: url('/static/img/default_profile/group-white.png');
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 20px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}

input[type=text]:focus {
  outline: none !important;
}

>>>.v-input .v-label {
  height: 20px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/CreateGroup_anoDialog.vue